// extracted by mini-css-extract-plugin
export default {"root":"DefaultActionBar_root__SCv-5"};